module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "modalTitle": 'Add Slot'
    },
    on: {
      "save": function($event) {
        return _vm.save()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('FormulateForm', {
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }, [_c('FormulateInput', {
    attrs: {
      "type": "time",
      "name": "start_time",
      "label": "Start Time",
      "validation": "required",
      "validation-messages": {
        required: 'Start Time is required'
      }
    },
    on: {
      "validation": _vm.checkValidation
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "time",
      "name": "end_time",
      "label": "End Time",
      "validation": "required|afterStart",
      "validation-rules": {
        afterStart: _vm.afterStart
      },
      "validation-messages": {
        afterStart: 'End Time must be after Start Time',
        required: 'End Time is required'
      }
    },
    on: {
      "validation": _vm.checkValidation
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76c7ae04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/AgentScheduleSlotModal.vue
// module id = 685
// module chunks = 0